<template>
  <BaseFormCard
    :heading="$route.meta.title"
    submit-title="Create"
    @submit="createTeam"
  >
    <BaseInput
      v-model="team.name"
      title="Name"
      name="name"
      type="text"
      placeholder="Name"
      required
      trim
    />
    <BaseInput
      v-model="team.descr"
      title="Description"
      name="description"
      type="text"
      placeholder="Description"
      required
      trim
    />
    <BaseInput
      v-model="team.ldap_group_dn"
      title="LDAP Group DN"
      name="ldap_group_dn"
      type="text"
      trim
    />
    <BaseInputCheckbox
      v-model="team.enable_cr_dash"
      title="Enable CR Dashboard"
      name="enable_cr_dash"
    />
    <BaseInputCheckbox
      v-model="team.enable_survey"
      title="Enable Survey"
      name="enable_survey"
    />
    <FieldError v-model="error" />
  </BaseFormCard>
</template>

<script>
/**
 * View to Create a new Team
 */
import teamAPI from '@/api/team'
import FieldError from '@/components/FieldError'

export default {
  components: {
    FieldError,
  },
  data () {
    return {
      team: {
        name: '',
        descr: '',
        ldap_group_dn: null,
        enable_cr_dash: false,
        enable_survey: false,
      },
      error: '',
    }
  },
  methods: {
    createTeam () {
      const team = this.team
      teamAPI.createTeam(team).then(resp => {
        this.$parent.$toasted.success(team.name + ' created')
        this.$router.push({ name: 'team_list' })
      }).catch(error => {
        this.error = error.message
      })
    },
    goBack () {
      this.$router.go(-1)
    },
  },
}
</script>
